<div class="wrap">
    <div class="w-12 ratio-2-1 ratio-1-2-s ratio-1-1-m">
        <iframe class="fill"
                [src]="url"
                frameborder="0"></iframe>
    </div>
</div>
